import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-neutral/5 relative overflow-hidden">
      {/* Geometric Background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-white/40 -skew-x-12 transform translate-x-1/4"></div>

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-5xl md:text-6xl font-bold text-primary mb-8">Start Your Project</h2>
            <div className="w-24 h-1 bg-accent mb-8"></div>
            <p className="text-gray-600 mb-12 text-xl font-light leading-relaxed">
              Ready to elevate your space? Contact us to schedule a consultation with our design team.
            </p>

            <div className="space-y-10">
              {/* Name and Title */}
              <div>
                <h3 className="text-3xl font-bold text-primary mb-2">Alejandro Dominguez</h3>
                <p className="text-gray-500 font-light text-lg uppercase tracking-wide">Owner</p>
              </div>

              {/* Contact Details */}
              <div className="space-y-6">
                <div className="flex items-center space-x-4 group">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-sm group-hover:bg-accent transition-colors duration-300">
                    <Phone size={18} className="text-primary group-hover:text-white transition-colors" />
                  </div>
                  <a href="tel:+17605403346" className="text-gray-600 text-lg hover:text-primary transition-colors">
                    +1 (760) 540-3346
                  </a>
                </div>
                
                <div className="flex items-center space-x-4 group">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-sm group-hover:bg-accent transition-colors duration-300">
                    <Mail size={18} className="text-primary group-hover:text-white transition-colors" />
                  </div>
                  <a href="mailto:source.space_18@outlook.com" className="text-gray-600 text-lg hover:text-primary transition-colors">
                    source.space_18@outlook.com
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-10 md:p-12 shadow-2xl relative"
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-accent"></div>
            <form className="space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <label className="block text-xs font-bold text-primary uppercase tracking-widest mb-3">Name</label>
                  <input type="text" className="w-full bg-gray-50 border-b-2 border-gray-200 p-4 focus:outline-none focus:border-accent transition-colors" placeholder="John Doe" />
                </div>
                <div>
                  <label className="block text-xs font-bold text-primary uppercase tracking-widest mb-3">Phone</label>
                  <input type="tel" className="w-full bg-gray-50 border-b-2 border-gray-200 p-4 focus:outline-none focus:border-accent transition-colors" placeholder="(555) 123-4567" />
                </div>
              </div>
              
              <div>
                <label className="block text-xs font-bold text-primary uppercase tracking-widest mb-3">Email</label>
                <input type="email" className="w-full bg-gray-50 border-b-2 border-gray-200 p-4 focus:outline-none focus:border-accent transition-colors" placeholder="john@example.com" />
              </div>

              <div>
                <label className="block text-xs font-bold text-primary uppercase tracking-widest mb-3">Message</label>
                <textarea className="w-full bg-gray-50 border-b-2 border-gray-200 p-4 focus:outline-none focus:border-accent transition-colors h-32" placeholder="Tell us about your project..."></textarea>
              </div>

              <button className="w-full bg-primary text-white py-5 uppercase tracking-[0.2em] text-sm font-bold hover:bg-accent transition-colors duration-300">
                Send Message
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
